"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateLiteral = void 0;
const types_1 = require("../types");
const primitive_literal_1 = require("./primitive-literal");
class DateLiteral extends primitive_literal_1.PrimitiveLiteral {
    constructor() {
        super(...arguments);
        this[Symbol.toStringTag] = 'DateLiteral';
        this.type = types_1.ExpressionType.Date;
    }
    format() {
        return this.value.toISOString();
    }
    clone() {
        return new DateLiteral(new Date(this.value));
    }
    accept(visitor) {
        visitor.visitDateLiteral(this);
    }
}
exports.DateLiteral = DateLiteral;
//# sourceMappingURL=date-literal.js.map